module.exports = __webpack_public_path__ + "img/Roboto-Medium.caaae1e.svg";